import Home from "@/views/md/Home.vue";
import Gallery from "@/views/md/Gallery.vue"
export default [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      keepAlive: true, //需要被缓存的组件
    },
  },
  {
    path: "/manage",
    name: "Manage",
    component: () => import("@/views/md/MovePc.vue"),
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("@/views/md/Test.vue"),
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery,
    meta: {
      requiresAuth: true,
      keepAlive: false, //需要被缓存的组件
    },
  },
];
